export const BOLETO = 'Boleto';

export const PAYMENT_METHOD_NAME = {
  ACH: 'ACH',
  AmericanExpress: 'American Express',
  Boleto: 'Boleto',
  DinersClub: 'Diners Club',
  Discover: 'Discover',
  Elo: 'Elo',
  Hipercard: 'Hipercard',
  MasterCard: 'MasterCard',
  PayPal: 'PayPal',
  Pix: 'Pix',
  SEPA: 'SEPA',
  Visa: 'Visa',
} as const;
